import { Activity } from '../types'
import { PurposeTemplateActivity } from '../../../../../../pure-js/types/PurposeTemplate'
import { generateActivityId } from './activityConfiguration'

/**
 * Hydrate a stored template activity list into concrete Activity instances.
 *
 * Each template entry is matched against `availableActivities` by type.
 * Stored config values (numberOfLoops, customSlotLength, duration) overlay the
 * base activity values, and a fresh unique id is assigned to each result.
 * Template entries whose type is not found in availableActivities are silently
 * skipped, preserving the order of the remaining activities.
 *
 * @param templateActivities - Stored template activities from a PurposeTemplate.
 * @param availableActivities - Hydrated available activities from useSprintWizardConfig().
 * @returns Hydrated Activity array ready for sprint creation state.
 */
export function hydrateTemplate(
  templateActivities: PurposeTemplateActivity[],
  availableActivities: Activity[]
): Activity[] {
  return templateActivities
    .map((ta): Activity | null => {
      const base = availableActivities.find((a) => a.type === ta.type)
      if (!base) return null
      return {
        ...base,
        id: generateActivityId(ta.type),
        ...(ta.numberOfLoops !== undefined && { numberOfLoops: ta.numberOfLoops }),
        ...(ta.customSlotLength !== undefined && { customSlotLength: ta.customSlotLength }),
        ...(ta.duration !== undefined && { duration: ta.duration })
      }
    })
    .filter((a): a is Activity => a !== null)
}
